export enum Mino {
  I = "i",
  J = "j",
  L = "l",
  O = "o",
  S = "s",
  T = "t",
  Z = "z",
  GARBAGE = "gb",
  BOMB = "bomb"
}
